// Defensive coercion helpers ported from the pilotapp, used by parsers that
// must never throw on malformed payloads.

// Note: arrays are objects, so `isRecord([])` is `true` by design.
export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null
}

export const toNonEmptyTrimmedString = (value: unknown): string | null => {
  if (typeof value !== 'string') return null

  const trimmedValue = value.trim()
  if (!trimmedValue) return null

  return trimmedValue
}

export const isValidDate = (value: unknown): value is Date => {
  return value instanceof Date && !Number.isNaN(value.getTime())
}

export const parseDateOrFallback = (value: unknown, fallbackDate: Date): Date => {
  const safeFallbackDate = isValidDate(fallbackDate) ? fallbackDate : new Date()

  if (isValidDate(value)) return value

  const parsedDate = new Date(value as string)
  if (!Number.isNaN(parsedDate.getTime())) return parsedDate

  return safeFallbackDate
}

export const toSafeISOString = (value: unknown, fallbackDate: Date = new Date()): string => {
  return parseDateOrFallback(value, fallbackDate).toISOString()
}
